var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmrVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.74 40.4461L119.109 39.7966L118.155 38.6731L118.113 31.1131L118.662 30.1321V28.7476L118.251 27.8641L118.662 27.1426L118.398 26.5516L118.662 25.6861L117.987 23.7931L116.298 23.1736L114.018 23.0611L112.277 22.4401L109.935 22.0441L97.0967 22.2166L94.4777 22.7236H84.8387V21.2596L82.7927 20.5276L81.9902 19.7386L83.8622 19.5691L84.7637 18.5551L84.8147 17.1436L84.3857 16.0831L80.0912 15.3466H68.2097L68.4347 19.7386H71.9822V22.2166L71.0807 23.0611H55.3127L54.7502 22.4986H44.5577L43.2632 20.5846L43.0667 16.1926H41.7437V25.2871L41.2937 26.2156H40.0547L39.6047 25.5961H37.4642V23.7376H31.5512L31.0442 24.5821H30.0587L29.8052 25.2856H26.4272L26.2022 26.1931H23.5277L22.6262 25.4956H12.9932L11.9792 24.3556L0.927246 24.5806V26.3821L1.64425 27.1741L0.927246 27.9031V29.4661L11.8937 29.5336L12.9917 28.6636H22.2557L23.5232 28.1566L26.4227 28.2901C26.4227 28.2901 25.1837 30.0016 25.0712 30.0016C24.9587 30.0016 25.0142 30.9871 25.0142 30.9871H39.0917L39.2282 32.5921L38.9072 34.0966L38.2682 35.7811L38.5352 36.6961H39.7112L40.7387 35.6761L50.0687 36.5011L61.1657 37.3021H72.6512C72.6512 37.3021 73.0412 37.8961 73.0502 37.9171C73.0592 37.9381 76.3142 39.9301 76.3142 39.9301L78.3077 41.5996L79.8977 46.6561L80.9627 47.9851L84.3827 48.0376L87.7187 45.7411L88.8857 45.5161L91.9217 44.3896L93.8702 44.2501L94.9037 43.5736L96.4037 42.9826L97.4177 43.9981L101.232 43.8481L101.888 43.3981L102.894 42.9811L112.017 42.2626L115.073 42.1366L118.283 42.2626L119.109 41.7661L118.811 41.0521L118.74 40.4461ZM10.2482 27.6901H4.88425V28.1971H3.44875V25.8526H4.84225V26.3806H10.2902C10.2902 26.3806 11.2187 26.4436 11.2187 27.1201C11.2187 27.6481 10.2467 27.6901 10.2467 27.6901H10.2482ZM79.3427 34.5106L79.6592 34.1101C79.6592 34.1101 79.6382 33.7096 79.6592 33.1816C79.6802 32.6536 80.3132 32.5906 80.3132 32.5906H82.8257C82.8257 32.5906 83.1002 33.8161 82.9952 34.4911C82.8902 35.1676 82.0022 35.4841 82.9112 35.3566C83.8187 35.2306 84.6212 34.6426 84.6212 34.6426C84.6212 34.6426 84.6842 35.5261 84.5372 36.1591C84.3887 36.7921 84.1367 36.6871 84.1367 36.6871H81.0857L80.7377 36.3706C80.7377 36.3706 80.2307 36.4126 79.8512 36.3706C79.4717 36.3286 79.3442 36.0121 79.3442 36.0121V34.5121L79.3427 34.5106ZM86.3957 44.5831L84.0722 45.8926L83.3117 46.6531L81.0737 45.5551C81.0737 45.5551 80.3987 41.7541 80.1017 40.7401C79.8062 39.7261 78.1592 39.1351 78.1592 39.1351C78.1592 39.1351 76.5542 38.4586 75.7937 38.0791C75.0332 37.6996 74.8217 37.2976 74.8217 37.2976V36.5401H76.6892L77.0597 37.2976H78.5807C78.7067 38.0791 80.8607 37.9096 80.8607 37.9096L83.9012 37.7836C83.9012 37.7836 84.9572 37.5721 85.3367 37.9951C85.7162 38.4181 85.5482 39.4951 85.5482 39.4951C85.5482 39.4951 86.2232 40.3606 86.3927 41.4586C86.5622 42.5566 85.9277 43.7821 85.9277 43.7821L86.3927 44.5846L86.3957 44.5831ZM95.5607 36.3481C95.5607 36.3481 95.0117 40.7401 92.8997 40.7401C90.7877 40.7401 91.0412 38.2066 90.3227 37.1086C89.6042 36.0106 88.7597 35.2351 88.8017 34.1656C88.8437 33.0961 89.3087 32.4631 90.1112 32.3776C90.9137 32.2936 91.8857 32.3776 91.8857 32.3776H95.5607V36.3481V36.3481Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1447 25.8331L51.5117 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2924 25.8331L53.6594 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4421 25.8331L55.8076 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5903 25.8331L57.9573 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7387 25.8331L60.1057 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8879 25.8331L62.2534 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0356 25.8331L64.4026 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.184 25.8331L66.551 26.5501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6448 27.1411L76.6888 26.3041L77.7748 27.1411H75.6448Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4026 27.1411L83.4451 26.3041L84.5326 27.1411H82.4026Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1584 27.1411L90.2009 26.3041L91.2884 27.1411H89.1584Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9143 27.1411L96.9568 26.3041L98.0443 27.1411H95.9143Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.672 27.1411L103.715 26.3041L104.802 27.1411H102.672Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.428 27.1411L110.47 26.3041L111.558 27.1411H109.428Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.747 26.3041L113.703 27.1411L112.617 26.3041H114.747Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.99 26.3041L106.947 27.1411L105.86 26.3041H107.99Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.234 26.3041L100.191 27.1411L99.1038 26.3041H101.234Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4779 26.3041L93.4354 27.1411L92.3479 26.3041H94.4779Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7216 26.3041L86.6776 27.1411L85.5901 26.3041H87.7216Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9642 26.3041L79.9217 27.1411L78.8342 26.3041H80.9642Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7845 26.3041L73.742 27.1411L72.6545 26.3041H74.7845Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4335 30.9856V33.6151L98.045 34.1656V37.6996L98.4335 38.2486V40.1926L96.4055 42.7261",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.104 37.2991H115.116",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8446 41.0507V42.5147L90.3381 43.6697L89.8596 44.9087",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M109.428 40.1222V41.0507H113.341V42.4127",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1467 35.8426L48.7652 34.4071C48.7652 34.4071 49.4402 33.5446 52.1432 33.6166C54.8462 33.6886 69.7127 33.3931 69.7127 33.3931",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7141 32.1676L46.6546 32.3416L45.2611 32.9701H43.4026V36.0196",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3889 15.3451V19.4971",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9641 15.4741V19.2856",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4729 15.3451V19.4971",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3528 28.2886V30.7741",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8469 28.9996V30.7741",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0557 25.2841V27.8386",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4243 26.1917V28.1551",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5247 26.1917V27.8386",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M100.545 34.6171V37.7431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8339 19.2316C79.1148 19.2316 79.3424 19.0039 79.3424 18.7231C79.3424 18.4423 79.1148 18.2146 78.8339 18.2146C78.5531 18.2146 78.3254 18.4423 78.3254 18.7231C78.3254 19.0039 78.5531 19.2316 78.8339 19.2316Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1448 16.8646V18.4411",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4729 21.9331H82.3139",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 32.4736C105.616 32.4736 105.675 32.4145 105.675 32.3416C105.675 32.2687 105.616 32.2096 105.543 32.2096C105.47 32.2096 105.411 32.2687 105.411 32.3416C105.411 32.4145 105.47 32.4736 105.543 32.4736Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M114.497 30.2641C114.57 30.2641 114.629 30.205 114.629 30.1321C114.629 30.0592 114.57 30.0001 114.497 30.0001C114.424 30.0001 114.365 30.0592 114.365 30.1321C114.365 30.205 114.424 30.2641 114.497 30.2641Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8129 32.4736C99.8858 32.4736 99.9449 32.4145 99.9449 32.3416C99.9449 32.2687 99.8858 32.2096 99.8129 32.2096C99.74 32.2096 99.6809 32.2687 99.6809 32.3416C99.6809 32.4145 99.74 32.4736 99.8129 32.4736Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2358 41.5306C99.3087 41.5306 99.3678 41.4715 99.3678 41.3986C99.3678 41.3257 99.3087 41.2666 99.2358 41.2666C99.1629 41.2666 99.1038 41.3257 99.1038 41.3986C99.1038 41.4715 99.1629 41.5306 99.2358 41.5306Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0.927979 24.3542H11.98L12.994 25.4942H22.624L23.5525 26.2127H26.425V25.2842H30.0565V24.5807H31.042L31.549 23.7362H37.462V25.5947H39.6025L40.0525 26.2142H41.2915L41.7415 25.5392V16.1912H43.2625V20.5832L44.557 22.4972H54.9745V23.0597H71.362V22.2152H71.9815V19.7372H68.434V15.3452H80.0905L83.5255 15.8522C83.5255 15.8522 84.595 15.7397 84.7645 16.7537C84.934 17.7677 84.7645 18.5552 84.7645 18.5552L83.863 19.5692H80.653V20.5262H82.7935L84.8395 21.2582V22.7222H95.2945C95.2945 22.7222 95.2375 22.2722 97.096 22.2152L98.9545 22.1582L109.766 22.0457C109.766 22.0457 111.512 21.9332 113.878 23.0597L116.299 23.1722C116.299 23.1722 117.707 23.4542 117.988 23.7917C117.988 23.7917 117.706 24.9182 118.663 25.0307V25.6847C118.663 25.6847 118.283 25.8107 118.283 26.2127C118.283 26.6147 118.663 26.7407 118.663 26.7407V27.5642C118.663 27.5642 118.198 27.5852 118.198 28.1552C118.198 28.7252 118.663 28.7462 118.663 28.7462V30.4562L118.114 31.1102L118.156 38.6702L119.338 40.0637C119.338 40.0637 118.663 40.2332 118.663 40.6967C118.663 41.1602 119.338 41.3717 119.338 41.3717C119.338 41.3717 119.212 41.9627 118.282 42.2582C117.352 42.5537 114.397 42.2582 114.397 42.2582L113.678 42.3902L102.275 43.0607L101.389 43.8212C101.389 43.8212 98.179 44.2862 96.9115 43.8212V42.9347H96.2785C96.2785 42.9347 95.899 43.4417 95.35 43.5257C94.801 43.6097 94.0405 43.4837 93.8725 44.2442C93.8725 44.2442 92.647 44.1182 91.339 44.5397C90.0295 44.9627 88.8895 45.5117 88.8895 45.5117H88.171L85.975 46.6097C85.975 46.6097 84.961 47.2007 84.5395 47.8352L81.7735 48.0047C81.7735 48.0047 80.1055 48.3632 79.6825 46.5902C79.2595 44.8157 78.5845 42.4307 78.5845 42.4307C78.5845 42.4307 78.373 41.0372 77.254 40.4252C76.135 39.8132 73.7275 38.6087 73.7275 38.6087C73.7275 38.6087 73.009 38.2292 72.967 37.5737L72.925 36.9197L72.25 37.2782L64.9435 37.4477C64.9435 37.4477 62.3665 37.3217 60.7195 37.2782C59.0725 37.2362 47.1625 36.2642 47.1625 36.2642L41.968 35.9267L40.7425 35.6732C40.7425 35.6732 40.489 36.9617 39.475 36.9407C38.461 36.9197 38.1235 36.4547 38.272 35.7797C38.4205 35.1047 39.0325 33.8372 39.0325 33.8372L39.223 33.3302L39.244 31.6907L40.0885 30.9857H24.61V30.0002H25.4125V28.9997H26.848V28.1552H23.3845L22.498 28.6622H12.9535L12.193 29.4647H0.927979V27.9017L1.75898 27.0572L0.927979 26.3822V24.3557V24.3542Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44751 26.0431V28.1971H4.88301V27.6901H10.247C10.247 27.6901 11.219 27.6481 11.219 27.1201C11.219 26.4451 10.2905 26.3806 10.2905 26.3806H4.84101V25.8526H3.44751V26.0431V26.0431Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9924 25.4941L12.9504 28.6621",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1018 25.4942V28.6622",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8469 28.1552H37.4474",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4602 25.5932V28.1552V30.9857",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.41 28.1552L39.98 27.8387H41.2685V29.4227H37.4465V28.1552H39.41Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0852 30.9857H70.1347V34.6592L69.2452 37.3472",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.135 30.9856H109.371L112.581 34.9966H115.707L116.392 30.3511L115.116 28.6306H96.8695L95.8135 29.3386H94.7155L93.6595 28.2826H83.7355V29.5066H73.684L72.3325 28.8316V24.9886L73.0075 24.4816L73.0915 23.6791L71.98 22.2151",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M73.053 24.0541H100.333V24.9031H114.016V23.0596",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.98 19.7372H73.7815L74.5705 20.4407H80.6515",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0627 30.9857L45.8932 25.7942H50.4127L50.9182 28.2887H51.9742L52.5232 27.5642H68.5732L69.0367 27.0992V23.2982",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9185 28.2886V30.9856",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8977 27.6197H50.7837",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M42.092 24.9031H69.0365",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M112.58 34.9966V35.8426H109.934V40.1221H102.894L99.6799 43.9951",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M112.581 35.8427H116.392V38.7557H109.935",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.392 38.7557L115.072 39.9392V42.1352",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.115 28.6307L115.072 23.2982",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8865 32.3791H95.5615V36.3496C95.5615 36.3496 95.0125 40.7416 92.9005 40.7416C90.7885 40.7416 91.042 38.2081 90.3235 37.1101C89.605 36.0121 88.7605 35.2366 88.8025 34.1671C88.8445 33.0976 89.3095 32.4646 90.112 32.3791C90.9145 32.2951 91.8865 32.3791 91.8865 32.3791V32.3791Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8235 36.5416V37.2991C74.8235 37.2991 75.035 37.6996 75.7955 38.0806C76.556 38.4616 78.161 39.1366 78.161 39.1366C78.161 39.1366 79.808 39.7276 80.1035 40.7416C80.399 41.7556 81.0755 45.5566 81.0755 45.5566L83.3135 46.6546L84.074 45.8941L86.3975 44.5846L85.9325 43.7821C85.9325 43.7821 86.5655 42.5566 86.3975 41.4586C86.228 40.3606 85.553 39.4951 85.553 39.4951C85.553 39.4951 85.7225 38.4166 85.3415 37.9951C84.962 37.5721 83.906 37.7836 83.906 37.7836L80.8655 37.9096C80.8655 37.9096 78.7115 38.0791 78.5855 37.2976H77.0645L76.694 36.5401H74.8265L74.8235 36.5416Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82.826 32.5907H80.3135C80.3135 32.5907 79.6805 32.6537 79.6595 33.1817C79.6385 33.7097 79.6595 34.1102 79.6595 34.1102L79.343 34.5107V36.0107C79.343 36.0107 79.469 36.3272 79.85 36.3692C80.2295 36.4112 80.7365 36.3692 80.7365 36.3692L81.0845 36.6857H84.1355C84.1355 36.6857 84.389 36.7907 84.536 36.1577C84.6845 35.5247 84.62 34.6412 84.62 34.6412C84.62 34.6412 83.8175 35.2292 82.91 35.3552C82.0025 35.4812 82.889 35.1647 82.994 34.4897C83.099 33.8147 82.8245 32.5892 82.8245 32.5892L82.826 32.5907Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8264 32.5906H85.9089C85.9089 32.5906 86.1204 33.6256 85.4229 33.7096C84.7254 33.7936 84.6084 34.3066 84.6204 34.6426",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmrVariant);
export default __webpack_public_path__ + "static/media/DMR Variant.457f676abcf4dc00c7d5159875f62157.svg";
export { ForwardRef as ReactComponent };